module.exports = __webpack_public_path__ + "img/sq1.0e051cc8.png";